'use client';

import React from 'react';
import dynamic from 'next/dynamic';
import type { HourlyPrice } from './DashboardShell';

interface PriceChartProps {
  prices: HourlyPrice[];
}

const PriceChartInner = dynamic(() => import('./PriceChartInner'), {
  ssr: false,
  loading: () => (
    <div className="w-full h-[320px] sm:h-[380px] skeleton-shimmer" />
  ),
});

export default function PriceChart({ prices }: PriceChartProps) {
  return <PriceChartInner prices={prices} />;
}